import React from "react";
import { Link } from "react-router-dom";
import "./LandingGrid.css";

export const SiteHeader = () => (
  <header className="lg-header">
    <div className="lg-brand-block">
      <Link to="/" className="lg-logo" aria-label="Alessandro Giustini home">
        AG
      </Link>
    </div>

    <p className="lg-based">BASED IN ROME</p>

    <nav className="lg-nav" aria-label="Primary">
      <Link to="/works">WORKS</Link>
      <Link to="/about">WHO I AM</Link>
      <Link to="/contact">CONTACT</Link>
    </nav>
  </header>
);
